import React from 'react';
import axios from 'axios';
import { BASE_URL } from '../../../../../../constants/config';
import { FALLBACK_FILTERS } from '../constants';

const buildFiltersFromApi = (apiFilters) => {
  return FALLBACK_FILTERS.filter((fallback) => {
    const apiOptions = apiFilters?.[fallback.key];
    return apiOptions && Array.isArray(apiOptions) && apiOptions.length > 0;
  }).map((fallback) => {
    const apiOptions = apiFilters[fallback.key];
    return { ...fallback, options: ['All', ...apiOptions] };
  });
};

export const useFilters = () => {
  const [filters, setFilters] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;

    const fetchFilters = async () => {
      try {
        const { data } = await axios.get(`${BASE_URL}/practitioners/filters`);
        if (!cancelled && data?.filters) {
          setFilters(buildFiltersFromApi(data.filters));
        }
      } catch {
        if (!cancelled) {
          setFilters([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchFilters();
    return () => {
      cancelled = true;
    };
  }, []);

  return { filters, loading };
};
